<template>
	<NoSsr />
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import useStore from 'webmd-cms-store/src/store';
import _pick from 'lodash/pick';
import NoSsr from '../client-only';

export default {
	name: 'SetRendered',
	components: {
		NoSsr,
	},
	created() {
		this.store = useStore(this.$pinia);
		const sharedObject = this.store.cms.getModules('shared_object');
		let guideObject = sharedObject.Guide_Article_Data;

		guideObject = _pick(guideObject, [
			'metadata_section.wbmd_c_channel_id',
			'metadata_section.title',
			'metadata_section.wbmd_prim_subj_cd',
			'content_section.cons_guide_outline.chapter_groups.chapter_group',
		]);

		/* eslint-disable max-len */
		guideObject.content_section.cons_guide_outline.chapter_groups.chapter_group	= guideObject.content_section.cons_guide_outline.chapter_groups.chapter_group.map((c) => {
			const sectionGroup = c.chapter_link.cons_guide_chapter_outline.section_groups.section_group.length
				? c.chapter_link.cons_guide_chapter_outline.section_groups.section_group : [c.chapter_link.cons_guide_chapter_outline.section_groups.section_group];
			/* eslint-enable max-len */
			return {
				chapter_link: {
					cons_guide_chapter_outline: {
						chapter_title: c.chapter_link.cons_guide_chapter_outline.chapter_title,
						section_groups: {
							section_group: sectionGroup.map((s) => {
								const articleGroup = s.article_groups.article_group.length
									? s.article_groups.article_group : [s.article_groups.article_group];

								return {
									section_full_title: s.section_full_title,
									article_groups: {
										article_group: sectionGroup.length > 1 ? articleGroup.map((a) => _pick(a, ['article_link.link_friendlyUrl', 'article_link._chronic_id', 'article_link.chapter__chronic_id', 'article_link_title']))
											: articleGroup.map((a) => _pick(a, ['article_link.link_friendlyUrl', 'article_link._chronic_id', 'article_link.chapter__chronic_id', 'article_link_title'])),
									},
								};
							}),
						},
					},
				},
			};
		});

		sharedObject.Guide_Article_Data = guideObject;

		this.store.cms.UPDATE_STATE({ key: 'shared_object', value: sharedObject });
	},
};
</script>
